
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import CacheManager from '../utils/cacheManager'

export default {
  name: 'TheNavbar',
  setup() {
    const store = useStore()
    const router = useRouter()
    const defaultAvatar = require('@/assets/default-avatar.svg')
    
    const isLoggedIn = computed(() => store.getters.isLoggedIn)
    const currentUser = computed(() => store.getters.currentUser)
    
    const handleLogout = async () => {
      // 清理所有缓存
      await CacheManager.clearAllCache()
      // 调用后端清除 Cookie 并清理本地状态
      await store.dispatch('logout')
      // 跳转到首页
      router.push('/')
    }

    const mobileMenuOpen = ref(false)

    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value
    }

    const closeMobileMenu = () => {
      mobileMenuOpen.value = false
    }
    
    return {
      isLoggedIn,
      currentUser,
      defaultAvatar,
      handleLogout,
      mobileMenuOpen,
      toggleMobileMenu,
      closeMobileMenu
    }
  }
}
